import axios from "axios";
import { Service } from "axios-middleware";
import user from "@/store/modules/user";
import router from "@/router/";

const service = new Service(axios);

const needsAPIToken = baseURL =>
  [process.env.API_URL, process.env.RD_STATION_URL].includes(baseURL);

service.register({
  onRequest(config) {
    if (needsAPIToken(config.baseURL) && localStorage.authentication)
      config.headers.Authorization = `Bearer ${localStorage.authentication}`;
    return config;
  },
  onResponseError(error) {
    let endpoint = error.response.config.url.split("/");
    endpoint = endpoint[endpoint.length - 1];

    if (error.response.status === 401 && endpoint != "authentication") {
      user.dispatch("logout");
      document.location.reload(true);
    }

    throw error;
  }
});

const withAccept = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/vnd.api+json",
    Accept: "application/json"
  }
});

const normal = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/vnd.api+json"
  }
});

const cloudinary = axios.create({
  baseURL: process.env.CLOUDINARY_URL,
  timeout: 30000,
  headers: {}
});

const freshdesk = axios.create({
  baseURL: process.env.FRESHDESK_URL,
  timeout: 30000,
  headers: { Authorization: `Basic ${btoa(process.env.FRESHDESK_API_KEY)}` }
});

const RDStation = axios.create({
  baseURL: process.env.RD_STATION_URL
});

export default {
  normal,
  withAccept,
  cloudinary,
  freshdesk,
  RDStation
};



// WEBPACK FOOTER //
// ./src/api/http.js